import React, { createContext, useContext, useState, useEffect } from 'react';

const CMS_API = 'https://github-skyline-pull.preview.emergentagent.com';

// Default contact info (fallback)
const defaultContactInfo = {
  name: 'MEMCO SKYLINE',
  phone: '+91-9187224980',
  email: 'info@memcoskyline.com',
  address: 'Off NH7 on Manipal County Road, Bengaluru – 560068',
  whatsapp: '+919187224980',
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=61588163955913',
    instagram: 'https://www.instagram.com/memcoskyline/',
    linkedin: 'https://www.linkedin.com/company/memco-skyline/',
    twitter: 'https://x.com/MEMCOSkyline',
    youtube: 'https://www.youtube.com/channel/UCdxanh_k5M852obG9aocTNg'
  }
};

// Create context
const CMSContext = createContext({
  home: null,
  design: null,
  amenities: null,
  location: null,
  contactInfo: defaultContactInfo,
  loading: true,
  error: null
});

// Provider component
export const CMSProvider = ({ children }) => {
  const [cmsData, setCmsData] = useState({
    home: null,
    design: null,
    amenities: null,
    location: null,
    contact_info: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCMS = async () => {
      try {
        console.log('[CMS] Fetching content...');
        const res = await fetch(`${CMS_API}/api/website-cms/public/all`);
        
        if (res.ok) {
          const data = await res.json();
          setCmsData(data);
          console.log('[CMS] Content loaded:', Object.keys(data));
        } else {
          // Silently handle non-200 responses - CMS is optional
          console.log('[CMS] Using default content (API returned:', res.status, ')');
        }
      } catch (err) {
        // Silently handle errors - CMS is optional, use defaults
        console.log('[CMS] Using default content');
      } finally {
        setLoading(false);
      }
    };

    fetchCMS();
  }, []);

  // Merge CMS contact info with defaults
  const contactInfo = {
    ...defaultContactInfo,
    ...(cmsData.contact_info || {})
  };

  const value = {
    home: cmsData.home,
    design: cmsData.design,
    amenities: cmsData.amenities,
    location: cmsData.location,
    contactInfo,
    loading,
    error
  };

  return (
    <CMSContext.Provider value={value}>
      {children}
    </CMSContext.Provider>
  );
};

// Hook to use CMS context
export const useCMSContext = () => {
  const context = useContext(CMSContext);
  if (!context) {
    throw new Error('useCMSContext must be used within CMSProvider');
  }
  return context;
};

// Hook for contact info only
export const useContactInfo = () => {
  const { contactInfo, loading } = useCMSContext();
  return { contactInfo, loading };
};

export default CMSContext;
